export const sortPeople = (people) => {
  const sortByName = (a, b) => {
    if ( a.name !== b.name ) {
      return a.name > b.name ? 1 : -1;
    } else {
      return 0;
    }
  };
  const sortByPoints = (a, b) => {
    if ( a.totalPoints !== b.totalPoints ) {
      return a.totalPoints > b.totalPoints ? -1 : 1;
    } else {
      return sortByName(a, b);
    }
  };
  return Object.keys(people).map(personId => {
    return {
      personId,
      ...people[personId],
    };
  }).sort((personA, personB) => {
    if (personA.attending !== personB.attending ) {
      if ( personA.attending ) return -1;
      if ( personB.attending ) return 1;
      return sortByPoints(personA, personB);
    } else {
      return sortByPoints(personA, personB);
    }
  });
};



// WEBPACK FOOTER //
// ./src/module/Sorting.js